/**
 * Creates OffscreenCanvas of given size.
 *
 * @param width
 * @param height
 */
export function makeCanvas(width: number, height: number): OffscreenCanvas;

/**
 * Creates OffscreenCanvas of given size.
 *
 * @param width
 * @param height
 * @param onscreen
 */
export function makeCanvas(
  width: number,
  height: number,
  onscreen: false
): OffscreenCanvas;

/**
 * Creates HTMLCanvasElement of given size.
 *
 * @param width
 * @param height
 * @param onscreen
 */
export function makeCanvas(
  width: number,
  height: number,
  onscreen: true
): HTMLCanvasElement;

/**
 * Creates OffscreenCanvas or HTMLCanvasElement.
 *
 * @param width
 * @param height
 * @param onscreen
 */
export function makeCanvas(
  width: number,
  height: number,
  onscreen: boolean
): OffscreenCanvas | HTMLCanvasElement;

/**
 * makeCanvas implementation.
 *
 * @param width
 * @param height
 * @param forceOnscreen
 */
export function makeCanvas(
  width: number,
  height: number,
  forceOnscreen = false
): HTMLCanvasElement | OffscreenCanvas {
  if (forceOnscreen) {
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }

  return new OffscreenCanvas(width, height);
}
